import { ComponentPropsWithoutRef, SVGProps } from 'react'
import { cn } from '~shared/utils/cn'
import Image from 'next/image'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'

type SwingIconProps = SVGProps<SVGSVGElement>

const SwingIcon5 = (props: SwingIconProps) => (
  <svg
    width='307'
    height='372'
    viewBox='0 0 307 372'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M193.499 434.5C-81.6444 385.809 580.499 0.500325 213.999 153.5C-138.962 300.848 112.361 -49.2219 379.196 -73.5674'
      stroke='#424242'
      strokeOpacity='0.7'
      strokeWidth='80'
    />
  </svg>
)
const SwingIcon4 = (props: SwingIconProps) => (
  <svg
    width='235'
    height='300'
    viewBox='0 0 235 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M193.636 371.237C-81.5077 322.546 580.636 -62.7626 214.136 90.2371C-138.826 237.585 112.498 -112.485 379.333 -136.83'
      stroke='#424242'
      strokeOpacity='0.7'
      strokeWidth='80'
    />
  </svg>
)

const SwingIcon3 = (props: SwingIconProps) => (
  <svg
    width='259'
    height='220'
    viewBox='0 0 259 220'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M188.636 370.237C-86.5077 321.546 575.636 -63.7626 209.136 89.2371C-143.826 236.585 107.498 -113.485 374.333 -137.83'
      stroke='#424242'
      strokeOpacity='0.7'
      strokeWidth='70'
    />
  </svg>
)

const SwingIcon2 = (props: SwingIconProps) => (
  <svg
    width='284'
    height='204'
    viewBox='0 0 284 204'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M188.636 347.237C-86.5077 298.546 575.636 -86.7626 209.136 66.2371C-143.826 213.585 107.498 -136.485 374.333 -160.83'
      stroke='#424242'
      strokeOpacity='0.7'
      strokeWidth='70'
    />
  </svg>
)

const SwingIcon1 = (props: SwingIconProps) => (
  <svg
    width='138'
    height='174'
    viewBox='0 0 138 174'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M96.0747 229.722C-40.1213 205.62 287.639 14.8924 106.222 90.6272C-68.4937 163.565 55.9113 -9.72003 187.995 -21.7711'
      stroke='#424242'
      strokeOpacity='0.7'
      strokeWidth='40'
    />
  </svg>
)

const SwingIcon = (props: SwingIconProps) => {
  const { className = '', ...rest } = props
  return (
    <>
      <SwingIcon1 className={cn('md:hidden', className)} {...rest} />
      <SwingIcon2
        className={cn('hidden md:block lg:hidden', className)}
        {...rest}
      />
      <SwingIcon3
        className={cn('hidden lg:block xl:hidden', className)}
        {...rest}
      />
      <SwingIcon4
        className={cn('hidden xl:block 2xl:hidden', className)}
        {...rest}
      />
      <SwingIcon5 className={cn('hidden 2xl:block', className)} {...rest} />
    </>
  )
}

const WhyUsCard = ({
  className,
  index,
  title,
  children,
  ...rest
}: { index: string; title: string } & ComponentPropsWithoutRef<'li'>) => {
  return (
    <li
      className={cn('relative rounded-[24px] overflow-hidden', className)}
      {...rest}>
      {children}
      <span className='absolute top-card-inner-indent left-card-inner-indent text-[14px] md:text-[16px] leading-[1.1]'>
        {index}
      </span>
      <p className='absolute inset-card-inner-indent top-auto text-[14px] md:text-[20px] xl:text-[24px] font-medium tracking-[-0.16px]'>
        {replacePrepositionsWhitespaces(title)}
      </p>
    </li>
  )
}

export interface WhyUsSectionProps
  extends ComponentPropsWithoutRef<'section'> {}

export const WhyUsSection = (props: WhyUsSectionProps) => {
  const { className = '', ...rest } = props

  return (
    <section className={cn('container container-slim', className)} {...rest}>
      <h2 className='typo-section-heading text-center'>
        {replacePrepositionsWhitespaces(
          'Почему выбирают «Московский институт технологий и управления»'
        )}
      </h2>
      <p className='typo-section-description mt-6 text-center'>
        Поступить в Московский Институт Технологий и Управления могут
        абитуриенты из любой страны. <br />
        Подробнее о правилах приёма иностранных граждан можно узнать,
        обратившись за консультацией <br /> к сотрудникам приёмной комиссии
      </p>
      <ul
        className={cn(
          'xl:pb-[150px]',
          'mt-[30px] md:mt-[24px] lg:mt-[40px] xl:mt-[60px]',
          'grid grid-cols-2 grid-rows-[174px_90px_174px_174px] gap-[10px]',
          'md:grid-cols-2 md:grid-rows-[204px_120px_120px_204px] md:gap-4',
          'lg:grid-cols-6 lg:grid-rows-[220px_143px_220px]',
          'xl:grid-cols-4 xl:grid-rows-[300px_300px]',
          '2xl:grid-rows-[372px_372px]'
        )}>
        <WhyUsCard
          index='01.'
          title='Прием иностранных граждан'
          className='text-primary lg:col-span-2 xl:col-span-1 translate-y-0 xl:translate-y-[45px]'>
          <Image
            alt='male'
            src='/assets/imgs/main-page/why-us-section-male.png'
            width={300}
            height={300}
            className='w-full select-none'
            draggable={false}
          />
        </WhyUsCard>
        <WhyUsCard
          index='02.'
          title='Возможность получить образование в рассрочку'
          className='text-primary lg:col-span-2 xl:col-span-1 bg-[#1D1D1D] translate-y-0 xl:translate-y-[150px]'>
          <SwingIcon className='text-[#424242] right-0 top-0 absolute' />
        </WhyUsCard>
        <WhyUsCard
          index='03.'
          title='Дипломы котируются по всему миру'
          className='lg:col-span-2 xl:col-span-1 bg-secondary'
        />
        <WhyUsCard
          index='04.'
          title='Цены ниже чем у конкурентов'
          className='text-tertiary md:text-primary lg:col-span-3 xl:col-span-1 bg-secondary md:bg-accent translate-y-0 xl:translate-y-[68px]'
        />
        <WhyUsCard
          index='05.'
          title='Сильный профессорский состав и практикующие преподаватели'
          className='text-primary lg:col-span-3 xl:col-span-1 bg-accent translate-y-0 xl:translate-y-[45px]'
        />
        <WhyUsCard
          index='06.'
          title='Ежемесячное зачисление на выбранную программу'
          className='text-primary md:text-tertiary lg:col-span-2 xl:col-span-1 bg-accent md:bg-secondary translate-y-0 xl:translate-y-[150px]'
        />
        <WhyUsCard
          index='07.'
          title='Легко совмещать с работой'
          className='text-primary lg:col-span-2 xl:col-span-1 bg-tertiary'>
          <Image
            alt='female'
            src='/assets/imgs/main-page/why-us-section-female.png'
            width={300}
            height={300}
            className='w-full select-none'
            draggable={false}
          />
        </WhyUsCard>
        <WhyUsCard
          index='08.'
          title='Возможность выбрать комфортное время и место для занятий'
          className='text-primary lg:col-span-2 xl:col-span-1 bg-[#1D1D1D] translate-y-0 xl:translate-y-[68px]'>
          <SwingIcon className='text-[#424242] right-0 top-0 absolute' />
        </WhyUsCard>
      </ul>
    </section>
  )
}
